export const AccessIsDenied = () => {
  return <h1 className="title">Access Is Denied Page</h1>;
};
